module.exports = __webpack_public_path__ + "img/naukri.b0c59442.svg";